import styles from './RecordingIndicator.module.scss';

const RecordingIndicator = () => (
  <div className={styles.container}>
    <i className={styles.circle} />
    <span className={styles.text}>rec</span>
  </div>
);

export default RecordingIndicator;
